import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TurnstileService } from '../services/turnstile.service';

export const turnstileInterceptor: HttpInterceptorFn = (req, next) => {
  const turnstileService = inject(TurnstileService);

  if (turnstileService.hasToken()) {
    const clonedReq = req.clone({
      setHeaders: {
        'X-Turnstile-Token': turnstileService.getToken()
      }
    });
    return next(clonedReq);
  }

  return next(req);
};
